import React, { useState } from 'react';
import "../style/style_form.css"

const Helpdesk = () => {
  const [formData, setFormData] = useState({jednostka: '', name: '', phone: '', description: ''});
  const [message, setMessage] = useState('');
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm(formData);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const response = await fetch('/api/tickets.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setMessage('Dziękujemy za zgłoszenie!');
      setFormData({jednostka: '', name: '', phone: '', description: ''});
      setFormErrors({});
    } else {
      setMessage('Wystąpił błąd przy wysyłaniu zgłoszenia.');
    }
  };

  // Walidacja formularza
  const validateForm = (data) => {
    const errors = {};
    if (!data.jednostka) errors.jednostka = "To pole jest wymagane";
    if (!data.name) errors.name = "To pole jest wymagane";
    if (!data.phone || !/^\d{9}$/.test(data.phone)) errors.phone = "Numer telefonu musi zawierać dokładnie 9 cyfr";
    if (!data.description) errors.description = "To pole jest wymagane";
    return errors;
  };

  return (
    <div className="helpdesk-form">
      <h2>Zgłoś problem</h2>
      <h2>(Wszystkie pola sa wymagane)</h2>
      <form onSubmit={handleSubmit}>
        <label>Jednostka:
          <input
              name="jednostka"
              id="jednostka"
              value={formData.jednostka}
              onChange={handleChange}
              required
          >
          </input>
          {formErrors.jednostka && <p className="error">{formErrors.jednostka}</p>}
        </label>
        <label>Imię Nazwisko: 
          <input 
            type="text" 
            name="name" 
            value={formData.name} 
            onChange={handleChange} 
            required 
          />
          {formErrors.name && <p className="error">{formErrors.name}</p>}
        </label>
        <label>Telefon: 
        <input 
            type="text"
            name="phone"
            value={formData.phone}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, ''); // usuń wszystko co nie jest cyfrą
              if (value.length <= 9) {
                setFormData({ ...formData, phone: value });
              }
            }}
            inputMode="numeric"
            maxLength={9}
            required
        />
          {formErrors.phone && <p className="error">{formErrors.phone}</p>}
        </label>
        <label>Opis: 
          <textarea 
            name="description" 
            value={formData.description} 
            onChange={handleChange} 
            required
          />
          {formErrors.description && <p className="error">{formErrors.description}</p>}
        </label>
        <button type="submit">Wyślij</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default Helpdesk;
